export default __webpack_public_path__ + "static/media/tata-thumbnail.bcc1fe73.png";